import { AfterViewChecked, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NewRevisionNoticeXmlSection } from 'src/app/model/section/new-revision-notice-xml-section';

import { ModalComponent } from '../../shared/modal/modal.component';

@Component({
  selector: 'app-new-revision-notice-xml-data',
  templateUrl: './new-revision-notice-xml-data.component.html',
  styleUrls: ['./new-revision-notice-xml-data.component.scss']
})
export class NewRevisionNoticeXmlDataComponent implements OnInit, AfterViewChecked {
  @Input() title: string = '';
  @Input() sections: NewRevisionNoticeXmlSection[] = [];

  @ViewChild('modal') modal!: ModalComponent;

  eventListenersAdded: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.modal && this.modal.close();
    this.eventListenersAdded = false;
  }

  ngAfterViewChecked(): void {
    let elements = (<HTMLElement>this.elementRef.nativeElement).querySelectorAll('.xmlModal');
    // console.log('elements : ', elements.length);
    if (elements.length > 0 && !this.eventListenersAdded) {
      this.eventListenersAdded = true;
      // console.log('eventListenersAdded : ', this.eventListenersAdded);
      elements.forEach((element) =>
        this.renderer.listen(element, 'click', () => {
          // console.log('title : ', element.getAttribute('title'));
          this.modal.open(element.getAttribute('title') || '');
        })
      );
    }
  }
}
